import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button, Scroller } from 'components'
import styles from './index.module.css'

const FincarIntro = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />,
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<div className="slider">
					<ul>
						<Scroller dotsStyle={styles.dotsStyle} dotStyle={styles.dotStyle} activeDotStyle={styles.activeDotStyle}>
							<li style={{ width: '100%' }} className={`scrollerItem ${styles.scrollerItem}`}>
								<i className="icon icon_fincar_intro01 ml_30" />
								<h3 className="intro-tit mt_20">중고차 안심하고 쇼핑하세요!</h3>
								<p className="intro-sub-tit mt_10">
									핀카에서 인증한 실매물의<br />
									투명한 가격 정보를 확인할 수 있어요!
								</p>
							</li>
							<li style={{ width: '100%' }} className={`scrollerItem ${styles.scrollerItem}`}>
								<i className="icon icon_fincar_intro02" />
								<h3 className="intro-tit mt_20">오직 나만을 위한 맞춤 상담을 받아보세요!</h3>
								<p className="intro-sub-tit mt_10">
									마이데이터로 연계한 내 정보에 맞춰<br />
									차량추천과 보험 및 금융상품 소개까지!
								</p>
							</li>
							<li style={{ width: '100%' }} className={`scrollerItem ${styles.scrollerItem}`}>
								<i className="icon icon_fincar_intro03" />
								<h3 className="intro-tit mt_20">매입부터 판매까지 핀카가 책임져요!</h3>
								<p className="intro-sub-tit mt_10">
									직영으로 운영하는 대형전시장에서<br />
									핀카 인증딜러의 체계적인 상담을 받아보세요!
								</p>
							</li>
						</Scroller>
					</ul>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">시작하기</Button>
			</div>
		</div>
	)
}

export default FincarIntro